<template>
    <div class="vp-message">
        <h2 class="vp-heading vp-message-title">{{ title }}</h2>
        <p class="vp-message-body">{{ body }}</p>
        <a v-if="actionUrl" :href="actionUrl" class="vp-outline-button">{{ actionLabel }}</a>
    </div>
</template>

<script setup>
// The page passes its own (translated) copy: the podcast offers its audio, the portal names the lesson.
defineProps({
    title: { type: String, required: true },
    body: { type: String, required: true },
    actionUrl: { type: String, default: null },
    actionLabel: { type: String, default: "" },
})
</script>
